import { ResultCode, TopazResult, BlockedReasonCode } from '@afterpaytouch/topaz-api'
import { topazResultCodeErrors, TopazStatus } from '../../model'

export const isValidTraceId = (traceId?: string): boolean => !['', undefined, null].includes(traceId?.trim())

export const handleTopazResultStatus = (topazResult: TopazResult): TopazStatus => {
  const resultCode = topazResult.resultCode
  const blockedReasonCode = topazResult?.blockedReasonCode ?? null

  const isIssuerRestricted =
    [BlockedReasonCode.ISSUER_RESTRICTED, BlockedReasonCode.CAPITAL_ONE_ISSUER_RESTRICTED].includes(blockedReasonCode as BlockedReasonCode) &&
    resultCode === ResultCode.UNACCEPTABLE_CARD

  if (isIssuerRestricted) {
    return TopazStatus.UnacceptableCardIssuerRestricted
  }

  return topazResultCodeErrors[resultCode] ?? TopazStatus.Error
}
